import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFlowState } from "@betterment/js-runtime";
import { F as FullPageLoader } from "./index-BEglnXN9.js";
const RedirectToPreviousStep = ({ fallback }) => {
  const { goToPreviousStep } = useFlowState();
  useEffect(() => {
    goToPreviousStep();
  }, [goToPreviousStep]);
  return fallback ?? /* @__PURE__ */ jsx(FullPageLoader, {});
};
export {
  RedirectToPreviousStep as R
};
//# sourceMappingURL=RedirectToPreviousStep-BwydGlvM.js.map
